import { BOARD_DETAIL_PATHNAME } from '@/shared/features/board/utils/boardEntryRoute';

// router.pathname 은 Next.js Pages Router의 라우트 템플릿이라 동적 세그먼트가
// 값이 아닌 대괄호 그대로 온다(예: 실제 URL '/play/abc' → pathname '/play/[entryMapHashId]').
const EXCLUDED_PATH_PREFIXES = [
  '/auth',
  '/sign-up',
  '/login',
  '/verification-phone',
  '/checkout',
  '/lti',
  '/play',
];

// 보드 상세는 `/board` 정확일치만 — prefix 로 두면 `/board/new`·`/board/landing` 까지 빠진다.
const EXCLUDED_EXACT_PATHS = [BOARD_DETAIL_PATHNAME];

export const isPhoneVerificationPromptRouteEligible = ({
  isInExternalPlatform,
  pathname,
}: {
  isInExternalPlatform: boolean;
  pathname: string;
}) =>
  !isInExternalPlatform &&
  !EXCLUDED_EXACT_PATHS.includes(pathname) &&
  !EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
